import React from "react";

function LhdnStripSection() {
  return (
    <section className="lhdn-strip">
      <div className="lhdn-strip__inner">
        <div>
          <p className="eyebrow">LHDN e-Invoice</p>
          <h3>LHDN e-Invoice ready. Included.</h3>
          <p>Auto-submitted to MyTax in real time. No extra cost.</p>
        </div>
        <span>Malaysia compliant</span>
      </div>
    </section>
  );
}

export default LhdnStripSection;
